export const defaultColours = [
	[1.0, 0.0, 0.0],
	[1.0, 0.6, 0.0],
	[0.8, 1.0, 0.0],
	[0.2, 1.0, 0.0],
	[0.0, 1.0, 0.4],
	[0.0, 1.0, 1.0],
	[0.0, 0.4, 1.0],
	[0.2, 0.0, 1.0],
	[0.8, 0.0, 1.0],
	[1.0, 0.0, 0.6]
];

// Old values:
// [1.0, 0.0, 0.0]			#ff0000
// [1.0, 0.78, 0.0]			#ffc800
// [0.75, 0.75, 0.75]		#bfbfbf
// [0.596, 0.933, 0.565]	#99ee91
// [0.0, 0.5, 0.08]			#008114

// New diagram values:
// every 36 degrees
// #ff0000	rgb(255,0,0)		[1.0, 0.0, 0.0]
// #ff9900	rgb(255,153,0)		[1.0, 0.6, 0.0]
// #ccff00	rgb(204,255,0)		[0.8, 1.0, 0.0]
// #33ff00	rgb(51,255,0)		[0.2, 1.0, 0.0]
// #00ff66	rgb(0,255,102)		[0.0, 1.0, 0.4]
// #00ffff	rgb(0,255,255)		[0.0, 1.0, 1.0]
// #0066ff	rgb(0,102,255)		[0.0, 0.4, 1.0]
// #3300ff	rgb(51,0,255)		[0.2, 0.0, 1.0]
// #cc00ff	rgb(204,0,255)		[0.8, 0.0, 1.0]
// #ff0099	rgb(255,0,153)		[1.0, 0.0, 0.6]
